import type { PublicApiKey } from '@/apilib';
import type { createSelectionApi } from './selectionWrapper';

export const SelectionApiKey: PublicApiKey<typeof createSelectionApi> = {
  name: 'SelectionApi',
  public: true,
};
